import { Box, Modal } from '@mui/material';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';

import BaseInputValidation from '@/components/ui/Input/BaseInputValidation';
import ButtonCloseModal from '@/components/ui/Button/ButtonCloseModal';

import ModalStyle from '@/constants/ModalStyle';

const schema = yup.object().shape({
	productversion: yup.string().required('Version is a required field'),
});

export default function Version(props) {
	const { open, onClose, onSave } = props;

	const {
		handleSubmit,
		control,
		reset,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
		defaultValues: {},
	});

    const handleClose = () => {
		reset();
		onClose();
	};

    const onSubmit = (data) => {
		const { productversion } = data;
		onSave(productversion);
		handleClose();
	};
	return (
		<Modal open={open} onClose={handleClose} aria-labelledby='modal-category-group' aria-describedby='modal-notes' className='w-full'>
			<Box sx={{ ...ModalStyle, top: '25%' }} className='flex flex-col gap-4 w-[90%] md:w-[380px]'>
				<span className='text-2xl modal-title'>Legg til ny versjion</span>
				<ButtonCloseModal onClose={handleClose} />

				<hr />

				<form onSubmit={handleSubmit(onSubmit)} className='flex flex-col w-full gap-4'>
					<BaseInputValidation control={control} name='productversion' label='Versjon' errors={errors} required />

					<div className='flex gap-4 ml-auto'>
						<button className='px-3 py-2 text-white rounded-md btn bg-primary' type='submit'>
							Legg til
						</button>
					</div>
				</form>
			</Box>
		</Modal>
	);
}
